import { Component, Input, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { ModalConfiguracionExtraPreguntaService } from "./modal-configuracion-extra-pregunta.service";
import { TipoConfiguracionPregunta } from "src/app/shared/enumeraciones/tipo-configuracion-pregunta.enum";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";

@Component({
  selector: "app-modal-configuracion-extra-pregunta",
  templateUrl: "./modal-configuracion-extra-pregunta.component.html",
  styleUrls: ["./modal-configuracion-extra-pregunta.component.scss"],
})

export class ModalConfiguracionExtraPreguntaComponent implements OnInit {
  @Input()
  modalGenerico: ModalGenericoModel;
  infoPregunta: any;
  pregunta_id: number;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER];
  formConfiguracionEncuesta: FormGroup;
  preguntaListaFiltrada: Observable<string[] | { value: number; name: string; }[]>;
  preguntaLista: any[] = [];
  tipoConfiguracionPregunta: TipoConfiguracionPregunta;

  tipoConfiguracionFormula = TipoConfiguracionPregunta.ConfiguracionFormula;
  tipoConfiguracionCondicion = TipoConfiguracionPregunta.ConfiguracionCondicion;
  tipoConfiguracionCondicionBloqueo = TipoConfiguracionPregunta.ConfiguracionCondicionBloqueo;

  modulos: any[] = [];
  preguntaListaTodas: any[] = this.modulos;

  isValid: boolean = false;
  isSyntaxisError: boolean = false;

  isEditing: boolean = false;

  @ViewChild('preguntaFormuladaInput') preguntaFormuladaInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('chipList', { static: false }) chipList: MatChipList;

  constructor(
    private activeModal: NgbActiveModal,
    private modalConfiguracionExtraPreguntaService: ModalConfiguracionExtraPreguntaService,
    private formBuilder: FormBuilder,
  ) {
    this.formConfiguracionEncuesta = formBuilder.group({
      preguntaFormulada: [],
      alerta: [null, ConfirmeValidators.noWhitespace]
    });
  }

  ngOnInit() {
    this.modalGenerico = {
      titulo: '',
    };



    this.modalConfiguracionExtraPreguntaService
      .getModulosSeccionesPreguntas({
        anio: this.infoPregunta.anio,
        pregunta_id: this.pregunta_id,
        clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
        es_formula_o_condicion: this.isCondicionOFormulada
      }).subscribe((resultado) => {
        if (resultado.data && resultado.data.length > 0) {
          this.modulos = resultado.data.reduce((acc, el) => {
            acc.push({
              id: el.modulo_encuesta_id,
              name: el.desc_modulo,
              value: null,
              isOperator: false
            });
            return acc;
          }, []);

          this.preguntaListaTodas = this.modulos;
          this.preguntaListaFiltrada = this.formConfiguracionEncuesta.get('preguntaFormulada').valueChanges.pipe(
            startWith(null),
            map((pregunta: string) => pregunta ? this._filter(pregunta) : this.preguntaListaTodas.slice()));
        }
      });

    switch (this.tipoConfiguracionPregunta) {
      case TipoConfiguracionPregunta.ConfiguracionFormula:
        this.modalConfiguracionExtraPreguntaService
          .getModulosSeccionesPreguntas({
            pregunta_encuesta_id: this.pregunta_id,
            clase_pregunta_id: this.infoPregunta.clase_pregunta_id
          }).subscribe((resultado) => {
            if (resultado.data && resultado.data.length > 0 && resultado.data[0].configuracion_formula)
              this.preguntaLista = [...JSON.parse(resultado.data[0].configuracion_formula)];
          });
        break;

      case TipoConfiguracionPregunta.ConfiguracionCondicion:
        const isAditional = this.infoPregunta.clase_pregunta_id === 2 ?? false;

        this.modalConfiguracionExtraPreguntaService
          .getCondicion(this.pregunta_id, isAditional)
          .subscribe((resultado) => {
            this.isEditing = !!resultado.data;
            if (resultado.data && resultado.data.length > 0 && resultado.data[0].configuracion_condicion) {
              this.preguntaLista = [...JSON.parse(resultado.data[0].configuracion_condicion)];
              this.formConfiguracionEncuesta.get("alerta").setValue(resultado.data[0].alerta);
            }
          });
        break;
      case TipoConfiguracionPregunta.ConfiguracionCondicionBloqueo:
        this.modalConfiguracionExtraPreguntaService
          .getModulosSeccionesPreguntas({
            pregunta_encuesta_id: this.pregunta_id,
            clase_pregunta_id: this.infoPregunta.clase_pregunta_id
          }).subscribe((resultado) => {
            if (resultado.data && resultado.data.length > 0 && resultado.data[0].configuracion_condicion_bloqueo)
              this.preguntaLista = [...JSON.parse(resultado.data[0].configuracion_condicion_bloqueo)];
          });
        break;
    }

  }

  agregarOperador(operator: string) {
    this.cambiarAModulos();

    this.preguntaLista.push({
      value: operator,
      name: operator,
      isOperator: true
    });

    this.isValid = false;
    this.isSyntaxisError = false;
    let elementScroll = (this.chipList as any)._elementRef.nativeElement.children[0];
    elementScroll.scrollLeft = elementScroll.scrollWidth;
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  close(): void {
    const valor = this.preguntaLista.reduce((acc, el) => {
      return `${acc} ${el.value}`;
    }, "");

    if (this.activeModal) {
      switch (this.tipoConfiguracionPregunta) {
        case TipoConfiguracionPregunta.ConfiguracionFormula:
          this.activeModal.close({
            clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
            pregunta_id: this.pregunta_id,
            es_formula: true,
            valor_formula: valor.trim(),
            configuracion_formula: JSON.stringify(this.preguntaLista)
          });
          break;
        case TipoConfiguracionPregunta.ConfiguracionCondicion:
          this.activeModal.close({
            clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
            pregunta_id: this.pregunta_id,
            condicion: valor.trim(),
            configuracion_condicion: JSON.stringify(this.preguntaLista),
            alerta: this.formConfiguracionEncuesta.value.alerta,
            activo: true,
            isEditing: this.isEditing
          });
          break;
        case TipoConfiguracionPregunta.ConfiguracionCondicionBloqueo:
          this.activeModal.close({
            clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
            pregunta_id: this.pregunta_id,
            es_formula: false,
            valor_formula: valor.trim(),
            configuracion_formula: JSON.stringify(this.preguntaLista)
          });
          break;

      }
    }
  }

  validate() {
    const valor = this.preguntaLista.reduce((acc, el) => {
      return `${acc} ${el.value}`;
    }, "");

    if (valor.length > 0) {
      this.modalConfiguracionExtraPreguntaService
        .createValidate({
          clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
          pregunta_encuesta_id: this.pregunta_id,
          valor_formula: valor.trim(),
          es_configuracion_formula: this.tipoConfiguracionPregunta == this.tipoConfiguracionFormula ? 1 : 0
        }).subscribe((resultado) => {
          this.isValid = resultado.result;
          if (resultado.result) this.isSyntaxisError = false;
          else this.isSyntaxisError = true;
        });
    } else this.isValid = true;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim() && !isNaN(Number(value.trim()))) {
      this.cambiarAModulos();

      this.preguntaLista.push({
        value: Number(value.trim()),
        name: value.trim()
      });
    } else if (this.tipoConfiguracionPregunta == TipoConfiguracionPregunta.ConfiguracionCondicion && (value || '').trim().length > 0 && isNaN(Number(value.trim()))) {
      this.preguntaLista.push({
        value: `'${value.trim()}'`,
        name: value.trim()
      });
    }

    if (input) input.value = '';

    this.formConfiguracionEncuesta.patchValue({ preguntaFormulada: null });
    this.isValid = false;
    this.isSyntaxisError = false;
  }

  remove(i: number): void {
    this.preguntaLista.splice(i, 1);
    this.cambiarAModulos();
    this.isValid = false;
    this.isSyntaxisError = false;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const lastValue = (this.preguntaLista.length > 0) ?
      this.preguntaLista[this.preguntaLista.length - 1] : { name: '', value: 1 };
    const lastSecondValue = (this.preguntaLista.length > 1) ?
      this.preguntaLista[this.preguntaLista.length - 2] : { name: '', value: 1 };

    this.preguntaLista.push({ ...event.option.value, remove: true });

    if (this.tipoConfiguracionPregunta == TipoConfiguracionPregunta.ConfiguracionCondicionBloqueo &&
      (lastValue.value &&
        event.option.value.value &&
        isNaN(lastValue.value) &&
        lastValue.value.includes("#") &&
        event.option.value.value.includes("#"))) {
      this.preguntaListaTodas = this.modulos;
      this.preguntaListaFiltrada = this.formConfiguracionEncuesta.get('preguntaFormulada').valueChanges.pipe(
        startWith(null),
        map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));

      this.preguntaLista.splice(this.preguntaLista.length - 2, 2);
      this.preguntaLista.push({
        name: `<span class="item-mat-chip">${lastValue.name}</span> <span class="item-mat-chip">${event.option.value.name}</span>`,
        value: event.option.value.value,
        isOperator: false
      });
    } else if (lastSecondValue.value === null) {
      if (this.tipoConfiguracionPregunta == TipoConfiguracionPregunta.ConfiguracionCondicionBloqueo) {
        this.modalConfiguracionExtraPreguntaService
          .getModulosSeccionesPreguntas({
            anio: this.infoPregunta.anio,
            pregunta_id: this.pregunta_id,
            clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
            es_formula_o_condicion: false,
            modulo_encuesta_id: lastSecondValue.id,
            seccion_encuesta_id: lastValue.id,
            pregunta_encuesta_id: event.option.value.id,
          }).subscribe((resultado) => {
            if (resultado.data && resultado.data.length > 0) {
              const opciones = resultado.data.reduce((acc, el) => {
                acc.push({
                  id: el.opcion_respuesta_id,
                  name: el.desc_opcion_respuesta,
                  value: `#${this.pregunta_id === event.option.value.id ?
                    "VALOR" : event.option.value.id}.${el.opcion_respuesta_id}#`,
                  isOperator: false
                });
                return acc;
              }, []);

              this.preguntaListaTodas = opciones;
            } else this.preguntaListaTodas = this.modulos;

            this.preguntaListaFiltrada = this.formConfiguracionEncuesta.get('preguntaFormulada').valueChanges.pipe(
              startWith(null),
              map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));

            this.preguntaLista.splice(this.preguntaLista.length - 3, 3);
            this.preguntaLista.push({
              name: `<span class="item-mat-chip">${lastSecondValue.name}</span> <span class="item-mat-chip">${lastValue.name}</span> <span class="item-mat-chip">${event.option.value.name}</span>`,
              value: event.option.value.value,
              isOperator: false
            });
          });
      } else {
        this.preguntaLista.splice(this.preguntaLista.length - 3, 3);
        this.preguntaLista.push({
          name: `<span class="item-mat-chip">${lastSecondValue.name}</span> <span class="item-mat-chip">${lastValue.name}</span> <span class="item-mat-chip">${event.option.value.name}</span>`,
          value: event.option.value.value,
          isOperator: false
        });

        this.preguntaListaTodas = this.modulos;
      }

    } else if (lastValue.value === null) {
      this.preguntaLista[this.preguntaLista.length - 2].remove = false;
      this.modalConfiguracionExtraPreguntaService
        .getModulosSeccionesPreguntas({
          anio: this.infoPregunta.anio,
          pregunta_id: this.pregunta_id,
          clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
          es_formula_o_condicion: this.isCondicionOFormulada,
          modulo_encuesta_id: lastValue.id,
          seccion_encuesta_id: event.option.value.id,
        }).subscribe((resultado) => {
          if (resultado.data && resultado.data.length > 0) {
            const preguntas = resultado.data.reduce((acc, el) => {
              acc.push({
                id: el.pregunta_encuesta_id,
                name: el.desc_pregunta,
                value: this.tipoConfiguracionPregunta == TipoConfiguracionPregunta.ConfiguracionFormula ? `#${lastValue.id}.${event.option.value.id}.${el.pregunta_encuesta_id}#`
                  : `#${this.pregunta_id === el.pregunta_encuesta_id ? "VALOR" : el.pregunta_encuesta_id}#`,
                isOperator: false
              });
              return acc;
            }, []);

            this.preguntaListaTodas = preguntas;
            this.preguntaListaFiltrada = this.formConfiguracionEncuesta.get('preguntaFormulada').valueChanges.pipe(
              startWith(null),
              map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));
          } else this.cambiarAModulos();
        });
    } else {
      this.modalConfiguracionExtraPreguntaService
        .getModulosSeccionesPreguntas({
          anio: this.infoPregunta.anio,
          pregunta_id: this.pregunta_id,
          clase_pregunta_id: this.infoPregunta.clase_pregunta_id,
          es_formula_o_condicion: this.isCondicionOFormulada,
          modulo_encuesta_id: event.option.value.id
        }).subscribe((resultado) => {
          if (resultado.data && resultado.data.length > 0) {
            const secciones = resultado.data.reduce((acc, el) => {
              acc.push({
                id: el.seccion_encuesta_id,
                name: el.titulo,
                value: null,
                isOperator: false
              });
              return acc;
            }, []);

            this.preguntaListaTodas = secciones;
            this.preguntaListaFiltrada = this.formConfiguracionEncuesta.get('preguntaFormulada').valueChanges.pipe(
              startWith(null),
              map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));
          } else this.cambiarAModulos();
        });
    }

    this.preguntaListaFiltrada = this.formConfiguracionEncuesta.get('preguntaFormulada').valueChanges.pipe(
      startWith(null),
      map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));

    this.preguntaFormuladaInput.nativeElement.value = '';
    this.preguntaFormuladaInput.nativeElement.blur();
    this.formConfiguracionEncuesta.patchValue({ preguntaFormulada: null });
    this.isValid = false;
    this.isSyntaxisError = false;
    let elementScroll = (this.chipList as any)._elementRef.nativeElement.children[0];
    elementScroll.scrollLeft = elementScroll.scrollWidth;
  }


  private _filter(value: string): string[] {
    const filterValue = value?.toLowerCase();

    return this.preguntaListaTodas.filter(pregunta => pregunta.name.toLowerCase().indexOf(filterValue) === 0);
  }

  private cambiarAModulos = () => {
    this.preguntaListaTodas = this.modulos;

    this.preguntaListaFiltrada = this.formConfiguracionEncuesta.get('preguntaFormulada').valueChanges.pipe(
      startWith(null),
      map((pregunta: any) => pregunta ? this._filter(pregunta.value) : this.preguntaListaTodas.slice()));

    this.preguntaLista = this.preguntaLista.reduce((acc, el) => {
      if (el.value !== null) acc.push(el);
      return acc;
    }, []);
  }

  get isCondicionOFormulada() {
    return (this.tipoConfiguracionPregunta == this.tipoConfiguracionFormula || this.tipoConfiguracionPregunta == this.tipoConfiguracionCondicion);
  }

  get isDisableButton() {
    if (this.tipoConfiguracionPregunta == this.tipoConfiguracionCondicion) {
      if ((this.formConfiguracionEncuesta.value.alerta && this.formConfiguracionEncuesta.get("alerta").valid && (!this.preguntaLista || this.preguntaLista.length == 0)) || (!this.formConfiguracionEncuesta.value.alerta || !this.formConfiguracionEncuesta.get("alerta").valid) && (this.preguntaLista && this.preguntaLista.length > 0)) {
        return true;
      }

      return false;

    } else {
      return false;
    }
  }
}
